import type { DetectionRegion } from '../types'

const HISTORY_LIMIT = 60

export function cloneRegions(regions: DetectionRegion[]): DetectionRegion[] {
  return regions.map((region) => ({ ...region, rect: { ...region.rect } }))
}

export function pushHistory(
  history: DetectionRegion[][],
  index: number,
  next: DetectionRegion[],
): { history: DetectionRegion[][]; index: number } {
  const truncated = history.slice(0, index + 1)
  truncated.push(cloneRegions(next))
  const limited = truncated.slice(-HISTORY_LIMIT)
  return { history: limited, index: limited.length - 1 }
}

export function undoHistory(history: DetectionRegion[][], index: number): { regions: DetectionRegion[]; index: number } | null {
  if (index <= 0) return null
  return { regions: cloneRegions(history[index - 1] ?? []), index: index - 1 }
}

export function redoHistory(history: DetectionRegion[][], index: number): { regions: DetectionRegion[]; index: number } | null {
  if (index >= history.length - 1) return null
  return { regions: cloneRegions(history[index + 1] ?? []), index: index + 1 }
}
